const initialProducttype = {
    producttypes : [],
    producttypemessages:{}
};

const productTypeReducer = (producttype = initialProducttype, action) => {
    switch (action.type) {
        case 'GET_PRODUCTTYPE':
          return {
            ...producttype, producttypes: action.payload.data
        };
        case 'ADD_PRODUCTTYPE':
          return {
            ...producttype, producttypemessages: action.payload.data
        };
        case 'UPDATE_PRODUCTTYPE':
          return {
            ...producttype, producttypemessages: action.payload.data
        };
        
          default:
            return producttype;
    }
}
export default productTypeReducer;